import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';
const LazyVehicleTypeHome = lazy(() => import('./VehicleTypeHome'));

const VehicleTypeHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyVehicleTypeHome {...props} />
  </Suspense>
);

export default VehicleTypeHome;

